import { Component, OnInit } from '@angular/core';
import { ObjectFrom } from '../../dynamic-form/models/input-form';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MyUtils } from 'src/app/services/my-utils.service';
import { DynamicFormServices } from '../../dynamic-form/services/dynamic-form.services';
import { LoaderService } from 'src/app/services/loader.service';
import { CompetitorsService } from 'src/app/services/competitors.service';
import { ApplicationService } from 'src/app/services/application.service';
import { cloneDeep, filter, map } from 'lodash';
import { mergeMap } from 'rxjs';

@Component({
  selector: 'app-competitors-dialog',
  templateUrl: './competitors-dialog.component.html',
  styleUrls: ['./competitors-dialog.component.scss']
})
export class CompetitorsDialogComponent implements OnInit {

  inputForm: ObjectFrom[] = [];
  formGroup: FormGroup = new FormGroup({});
  showButton: boolean = false;
  multiresponse: any;
  competitorsList: { key: string; value: string }[] = [];
  dealerID: string = "";

  constructor(
    private dialogRef: MatDialogRef<CompetitorsDialogComponent>,
    public utils: MyUtils,
    private dynamicFormService: DynamicFormServices,
    private loaderService: LoaderService,
    private competitorsService: CompetitorsService,
    private applicationService: ApplicationService
  ) {
    // this.competitorsService.getAll(payload).subscribe(el => {
    //   //console.log(el)
    // })
    // this.competitorsService.getMaseratiCompetitorsList().subscribe((el)=>{

    //   this.multiresponse = el;
    //   this.multiresponse.filter((el: any) => {
    //     //console.log(el.name)
    //   })
    this.competitorsService.getMaseratiCompetitorsList().subscribe(el => {
      let payload = cloneDeep(this.utils.settingsPayloadValue.payload);
      payload.question.section = this.applicationService.navBarSelectValue.idItem;
      payload.question.locale = this.applicationService.languageSelectValue;
      this.dealerID = payload.network.dealer.toString();
      this.competitorsList = el.map(item => ({
        key: item.enterpriseId,
        value: item.name
      }));
    

      this.configureInputForm(this.competitorsList)
      this.formGroup = this.dynamicFormService.generateFormGroup(this.inputForm);
      this.showButton = true;
      this.loaderService.stopLoader();
    })
  }

  configureInputForm(competitorsList: { key: string; value: string }[]){

    //console.log(competitorsList)
    
    this.inputForm = [
      [
        {
          formControlName: "dealerId",
          label: "Dealer Id",
          placeholder: "Dealer Id",
          value: this.dealerID,
          validators: {
            required: false,
          },
          template: "input",
          disabled: false,
          isHidden: true
        },
      ],
      [
        {
          formControlName: "enterpriseIdComp",
          label: this.utils?.traslatei18n("Enterprise_Id_Comp"),
          placeholder: "Enterprise Id Comp",
          value: "",
          validators: {
            required: true,
          },
          objectSelect: competitorsList,
          viewValueSelect: "value",
          keySelect: "key",
          template: "autocomplete",
          disabled: false,
        },
      ],
      [
        {
          formControlName: "competitorsName",
          label: this.utils?.traslatei18n("Competitors_Name"),
          placeholder: "Competitors Name",
          value: undefined,
          validators: {
            required: true,
          },
          template: "input",
          isMultipleSelect: true,
          disabled: false,
        },
      ],
      [
        {
          formControlName: "businessId",
          label: "Business Id",
          placeholder: "Business Id",
          value: undefined,
          validators: {
            required: false,
          },
          template: "input",
          disabled: false,
          isHidden: true
        },
      ],
      [
        {
          formControlName: "countryCode",
          label: this.utils?.traslatei18n("Country_Code"),
          placeholder: "Country Code",
          value: undefined,
          validators: {
            required: true,
          },
          template: "input",
          disabled: false,
        },
      ],
      [
        {
          formControlName: "zip",
          label: this.utils?.traslatei18n("Zip"),
          placeholder: "Zip",
          value: undefined,
          validators: {
            required: true,
          },
          template: "input",
          disabled: false,
        },
        {
          formControlName: "phone",
          label: "Phone",
          placeholder: "Phone",
          value: undefined,
          validators: {
            required: true,
          },
          template: "input",
          disabled: false,
        },
      ],
    ];

  }

  ngOnInit(): void {
    // this.competitorsService.listCompetitorsEnterpriseId()
    // .subscribe(data => {
    //   let competitorsCtrl = this.dynamicFormService.returnElementItemForm(
    //     this.inputForm,
    //     "enterpriseIdComp"
    //   )
    //   competitorsCtrl!.objectSelect = data;
    //   //console.log(data)
    //   //console.log(competitorsCtrl)
    // })
  }


  onSave() {
    if (!this.formGroup.valid) return;
    let formValue = this.formGroup.value;

    this.dialogRef.close(formValue)
  }

}
